// CORE14-F1 (docs/build-briefs/CORE14-F1-recipe-edit-history.md, section 5.2): the units a recipe ingredient can be
// measured in. A fixed list, never typed: the editor offers it as a picker and the server refuses anything else.
// Shared by the server and the recipe editor so the two can never disagree.

export const RECIPE_UNITS = [
  "oz",
  "ml",
  "dash",
  "drop",
  "splash",
  "barspoon",
  "tsp",
  "tbsp",
  "each",
  "leaf",
  "slice",
] as const;

export type RecipeUnit = (typeof RECIPE_UNITS)[number];

export const DEFAULT_RECIPE_UNIT_VALUE: RecipeUnit = "oz";

const RECIPE_UNIT_LABELS: Record<RecipeUnit, string> = {
  oz: "oz",
  ml: "ml",
  dash: "dash",
  drop: "drop",
  splash: "splash",
  barspoon: "barspoon",
  tsp: "tsp",
  tbsp: "tbsp",
  each: "each",
  leaf: "leaf",
  slice: "slice",
};

export function isRecipeUnit(value: string): value is RecipeUnit {
  return (RECIPE_UNITS as readonly string[]).includes(value);
}

export function recipeUnitLabel(value: RecipeUnit): string {
  return RECIPE_UNIT_LABELS[value];
}
